<template>
  <b-card no-body class="mt-4">
    <b-card-header>
      <span class="text-muted text-uppercase">{{ card_header }}</span>
    </b-card-header>
    <b-card-body>
      <b-input-group class="mb-3">
        <template #append>
          <b-input-group-text>
            <i class="fa fa-search mr-3" />
            <b-form-checkbox
              :checked="all_checked"
              inline
              class="mr-1"
              @change="toggleAll"
            >
              <strong>Toggle All</strong>
            </b-form-checkbox>
          </b-input-group-text>
        </template>
        <b-form-input
          v-model.trim="search_input"
          debounce="500"
          type="text"
          :placeholder="search_placeholder"
        />
      </b-input-group>
      <template v-if="filtered_collection.length">
        <b-row class="pr-3 pb-3">
          <b-col
            v-for="(item, index) in page"
            :key="index"
            cols="6"
            class="pr-0"
          >
            <b-form-checkbox v-model="checked" :value="item.id" inline>
              <strong>{{ formatName(item) }}</strong>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <custom-table-pagination
          :current_page="current_page"
          :per_page="per_page"
          :total_rows="total_rows"
          :options="page_options"
          @update="updatePaginationData"
        />
      </template>
      <b-alert v-else show class="py-1 m-0">
        <i class="fa fa-exclamation-circle" /> No matches found.
      </b-alert>
    </b-card-body>
  </b-card>
</template>

<script>
import CustomTablePagination from "@/components/shared/CustomTablePagination";

export default {
  name: "CustomCheckboxListForm",
  components: { CustomTablePagination },
  props: {
    collection: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    name_fields: {
      type: Array,
      default: () => [],
    },
    card_header: {
      type: String,
      default: "",
    },
    form_data_field: {
      type: String,
      default: "",
    },
    search_placeholder: {
      type: String,
      default: "Search...",
    },
    page_options: {
      type: Array,
      default: () => [10, 20, 30]
    },
    custom_per_page: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      current_page: 1,
      per_page: this.custom_per_page || 10,
      search_input: null,
    };
  },
  computed: {
    checked: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit("updateFormData", this.form_data_field, value);
      },
    },
    filtered_collection() {
      return this.collection.filter(({ name }) => {
        return this.search_input ? name.includes(this.search_input) : true;
      });
    },
    all_checked() {
      return this.page.reduce((acc, { id }) => {
        return (
          acc && !!this.selected.find((selected_item) => selected_item === id)
        );
      }, true);
    },
    page() {
      const begin = (this.current_page - 1) * this.per_page;
      const end = begin + this.per_page;

      return this.filtered_collection.slice(begin, end);
    },
    total_rows() {
      return this.filtered_collection.length;
    },
  },
  methods: {
    updatePaginationData({ field, value }) {
      this[field] = value;
    },
    formatName(checkbox_item) {
      return this.name_fields.reduce(
        (acc, cur) => `${acc} ${checkbox_item[cur]}`,
        ""
      );
    },
    toggleAll() {
      this.$emit(
        "updateFormData",
        this.form_data_field,
        this.all_checked
          ? this.selected.filter(
              (selected_item) =>
                !this.filtered_collection.find(({ id }) => id === selected_item)
            )
          : this.filtered_collection.reduce((acc, { id }) => {
              return this.selected.find((selected_item) => selected_item === id)
                ? acc
                : [...acc, id];
            }, this.selected)
      );
    },
  },
};
</script>
